const int = (n) => (n || n === 0 ? Math.round(n).toLocaleString() : "—");

/** How far one county is from Brazil's own density on courts, grounds and stadiums. */
export const BrazilGap = ({ gap, county, testId = "brazil-gap" }) => {
  if (!gap?.rows?.length) return null;
  const usd = (n) => (n ? `$${Math.round(n).toLocaleString()}` : "—");
  return (
    <section data-testid={testId}>
      <h2 className="font-display text-lg uppercase tracking-tight text-ochre print:text-black md:text-xl">
        The Brazil gap in {county}
      </h2>
      <p className="mt-3 max-w-3xl text-xs leading-relaxed text-zinc-500 print:text-zinc-600">{gap.note}</p>
      <div className="mt-4 border border-zinc-800 p-4 print:border-zinc-400" data-testid={`${testId}-closing-cost`}>
        <p className="mono text-[0.55rem] uppercase tracking-[0.16em] text-zinc-400 print:text-zinc-600">
          Cost of closing the gap entirely
        </p>
        <p className="mono mt-2 text-sm text-ochre print:text-black">{usd(gap.closing_capex_usd)}</p>
        <p className="mt-2 max-w-3xl text-xs leading-relaxed text-zinc-500 print:text-zinc-600">{gap.closing_note}</p>
      </div>
      <div className="mt-4 overflow-x-auto border border-zinc-800 print:border-zinc-400">
        <table className="w-full min-w-[720px] text-left">
          <thead>
            <tr className="border-b border-zinc-800 bg-[#0b0b0b] print:bg-white">
              {["Brazil measure", "Per million", "This county needs", "Planned here", "Still short", "Share of Brazil", "Cost to close"].map((h) => (
                <th key={h} className="mono px-3 py-2.5 text-[0.55rem] uppercase tracking-[0.14em] text-zinc-300 print:text-zinc-700">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {gap.rows.map((r) => (
              <tr key={r.measure} className="border-b border-zinc-900 print:border-zinc-300"
                data-testid={`${testId}-row-${r.measure.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <td className="px-3 py-3 text-sm text-white print:text-black">{r.measure}</td>
                <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">{r.brazil_per_million}</td>
                <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">{int(r.county_needed)}</td>
                <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">{int(r.county_planned)}</td>
                <td className="mono px-3 py-3 text-sm text-maasai print:text-black">{int(r.gap)}</td>
                <td className="mono px-3 py-3 text-xs text-ochre print:text-black">{r.share_of_brazil_pct}%</td>
                <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">{usd(r.gap_capex_usd)}</td>
              </tr>
            ))}
            <tr data-testid={`${testId}-academies`}>
              <td className="px-3 py-3 text-sm text-white print:text-black">County academies</td>
              <td className="mono px-3 py-3 text-xs text-zinc-500 print:text-zinc-600">No register</td>
              <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">{int(gap.academies_target)}</td>
              <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">{int(gap.academies_planned)}</td>
              <td className="mono px-3 py-3 text-sm text-maasai print:text-black">{int(gap.academies_gap)}</td>
              <td className="mono px-3 py-3 text-xs text-zinc-500 print:text-zinc-600">—</td>
              <td className="mono px-3 py-3 text-xs text-zinc-300 print:text-zinc-700">
                {usd(gap.academies_gap_capex_usd)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mt-3 max-w-3xl text-xs leading-relaxed text-zinc-500 print:text-zinc-600">{gap.academies_note}</p>
    </section>
  );
};
